module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IArs4c6QAAAIFQTFRFAAAA/38q/4gk/4Yi/4cj/4Yi/4ci/4Yi/4Yh/4Yi/4gm/4ko/44w/44x/5E2/5E3/5Y//5tI/6FU/6JV/6RZ/6Va/6xn/69t/7Jz/72G/72I/8ST/8aX/8me/8ug/82l/86l/9Cq/9Cr/9i4/9m6/9m7/9u+/9/E/+DH/+PM/+rZJtHkQQAAAAl0Uk5TAAYrj5O81PL8TlRVSwAAAI5JREFUGNOVkMkOwjAQQ6dNmuRRlrLve4DC/38gh7RVkIIEPj7JHo9F/lSujLVG5RHKtAMAp7OOFXQqWqoBKHcvAN3kOYBJvfAALuQqGM725wGeagpKREQMPNdz4Eb/CEZERCzcAfBwAfsdGqgPq2A/tXYFZbW5jj4OhUrjxzKu1JTvbePy6TeTg6Sn+0lvZJQKOLxgMMUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/icon_news.png
// module id = 4zrG
// module chunks = 1